import api from "./apiClient";

// Fetch groups data
export const fetchGroups = async () => {
  return await api.get("/group/retrieve");
};

// Fetch saved searches for a specific user
export const fetchSavedSearches = async (userId) => {
  return await api.get(`/custom_search/${userId}/`);
};

// Fetch graph data
export const fetchGraphData = async (userId) => {
  return await api.post(`/graph/search/${userId}/`, {
    includeClasses: [],
    includeTopics: [],
    includeKeywords: ["test"],
    includeManualAndExpand: [],
  });
};

// Fetch the topic graph data
// export const fetchTopicGraph = async (userId) => {
//     try {
//       const response = await api.get(`/topics/${userId}/`);
//       return response.data;
//     } catch (error) {
//       throw new Error('Error fetching topic graph');
//     }
//   };

export const fetchSchemaGraph = async () => {
  const response = await api.get("/schema/graph");
  return response.data;
};

export const fetchTopicGraph = async (userId) => {
  const response = await api.get(`/topics/${userId}/`);
  return response.data;
};
